import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
`;

export const Wrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 12px;
  }
`;

export const BasketErrorText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.black};
`;

export const ImagesWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0px;
  }
`;

export const BreadcrumbWrapper = styled.div`
  width: 100%;
  display: flex;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 24px 0;
  align-items: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 12px;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.grey300};
`;

export const GoBack = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey800};
  margin-left: 6px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;

export const Seperator = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${({ theme }) => theme.palette.grey300};
  margin: 0 24px;
`;

export const HeaderWrapper = styled.div`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 20px;
    padding-top: 20px;
  }
`;

export const RoomWarning = styled.div`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 40px 40px 16px 40px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 3px 0 2px 0;
  }
`;

export const SearchBarWrapper = styled.div`
  max-width: fit-content;
`;

export const DetailSearchBarContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;

export const DetailSearchWrapper = styled.div<{
  sticky?: boolean;
  animated: boolean;
}>`
  margin: 0 auto;
  ${({ sticky }) => `
  margin-top: ${sticky ? '0' : ' 32px'};
  padding: ${sticky ? '10px 0' : '0'};
  position: ${sticky ? 'fixed' : 'unset'};
  width: ${sticky ? '100vw' : 'fit-content'};
  `}
  z-index: 999;
  left: 0;

  top: ${({ animated }) => (animated ? '0' : '-200px')};

  transition: all 0.35s;
  display: flex;
  background-color: ${({ sticky, theme }) =>
    sticky ? theme.palette.white : 'transparent'};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
`;

export const HotelLocationWrapper = styled.div`
  margin: 20px 0;
`;

export const TabMenuWrapper = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.grey300}`};
  overflow-x: auto;
  scroll-behavior: smooth;
  margin-bottom: 40px;
  white-space: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const AnnouncementWrapper = styled.div`
  padding-bottom: 100px;
`;

export const TourismCertificateWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
  max-width: 1200px;
  align-items: flex-start;
  margin: 4px 0;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 8px;
  }
`;

export const TourismCertificateText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.eclipse};
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grey1100};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
    margin-left: 10px;
  }
`;
